<atn-ds-integrated-horizontal-tabs>
  <ng-template
    atnDsTab
    name="Definitions"
  >
    <atn-ds-table [config]="definitionsTableConfig" />
  </ng-template>

  <ng-template
    atnDsTab
    name="Connectors"
  >
    <atn-ds-table [config]="connectorsTableConfig" />
  </ng-template>
</atn-ds-integrated-horizontal-tabs>

<atn-integration-definition-modal />
<atn-integration-connector-modal />

@let deletedDefinitions =
  definitionsEc.plugins.editingPlugin.feature.selectors
    .deletedEntities()
    .asSignal();
@if (deletedDefinitions[0]; as definition) {
  @let deletionError =
    definitionsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete connector definition"
    [description]="
      'Are you sure you want to delete <b>' +
      definition.id +
      '</b>? This action cannot be undone.'
    "
    [error]="deletionError"
    [validation]="definition.id"
    confirmButtonText="Delete"
    (cancel)="cancelDefinitionDeletion()"
    (confirm)="confirmDefinitionDeletion()"
  />
}

@let deletedConnectors =
  connectorsEc.plugins.editingPlugin.feature.selectors
    .deletedEntities()
    .asSignal();
@if (deletedConnectors[0]; as connector) {
  @let deletionError =
    connectorsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete connector"
    [description]="
      'Are you sure you want to delete <b>' +
      connector.id +
      '</b>? This action cannot be undone.'
    "
    [error]="deletionError"
    [validation]="connector.id"
    confirmButtonText="Delete"
    (cancel)="cancelConnectorDeletion()"
    (confirm)="confirmConnectorDeletion()"
  />
}
